export default {
  // Page
  采购订单记录: "Purchase Order Records",

  // FooterActions
  返回: "Back",

  // OrderInfoCard
  订单信息: "Order Information",
  订单状态: "Order Status",
  采购单号: "Purchase Order No.",
  需求人: "Requester",
  需求部门: "Requesting Department",
  PO创建时间: "PO Creation Time",
  工厂: "Factory",
  物料类别: "Material Category",
  二级物料类别: "Secondary Material Category",

  // DeliveryTable
  交货次数: "Delivery Count",
  发货批次: "Shipment Batch",
  发货数量: "Shipped Quantity",
  发货时间: "Shipment Time",
  收货数量: "Received Quantity",
  收货时间: "Received Time",
  交货明细: "Delivery Details",
  已发货数量: "Shipped Quantity",
  已收货数量: "Received Quantity",
  待发货数量: "Pending Shipment",

  // PurchaseInfoCard
  采购信息: "Purchase Information",
  物料类型: "Material Type",
  生产性物料: "Production Material",
  非生产性物料: "Non-Production Material",
  供应商编号: "Supplier Code",
  供应商中文名称: "Supplier Name (CN)",
  供应商英文名称: "Supplier Name (EN)",
  采购组: "Purchasing Group",
  币种: "Currency",
  汇率: "Exchange Rate",
  付款条约: "Payment Terms",
  国际贸易条款: "Incoterms",
  发货地址: "Shipping Address",
  发货联系人: "Shipping Contact",
  发货联系电话: "Shipping Phone",

  // ProductInfoCard
  采购产品信息: "Purchased Product Information",
  项目号: "Project No.",
  物料编号: "Material No.",
  物料组: "Material Group",
  会计科目: "GL Account",
  PO数量: "PO Quantity",
  单位: "Unit",
  价格: "Price",
  价格单位: "Price Unit",
  原币金额: "Original Currency Amount",
  "本币金额（HKD）": "Local Amount (HKD)",
  "收货本币金额（HKD）": "Received Amount (HKD)",
  "发票已付本币金额（HKD）": "Invoice Paid Amount (HKD)",
  计划交货日期: "Planned Delivery Date",
  库位: "Storage Location",
  收货地址: "Delivery Address",
  收货联系人收货联系电话: "Receiver Contact",

  // useOrderStatusOptions
  待发货: "Pending Shipment",
  已发货: "Shipped",
  已部分收货: "Partially Received",
  已收货: "Received",
  待收款: "Pending Payment",
  已部分收款: "Partially Paid",
  已收款: "Paid",

  // usePurchaseOrderRecordBehavior
  操作: "Action",
  查看: "View",
  发货状态: "Shipping Status",
  付款状态: "Payment Status",
  订单编号: "Order No.",
  PO编号: "PO No.",
  产品名称: "Product Name",
  供应商编码: "Supplier Code",
  供应商: "Supplier",
  金额: "Amount",
  "收货联系人/收货联系电话": "Receiver Contact",
  请输入物料编号或名称搜索: "Search by material code or name",
  请输入供应商编号或名称搜索: "Search by supplier code or name",
};
